import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/common/icon-help.svg'


const _hoisted_1 = { class: "p-recommend-inner -is-form" }
const _hoisted_2 = { class: "p-recommend-form__send-field" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "保存して次へ", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "p-recommend-form__modal-card -is-help" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "p-recommend-form__icon-1",
  src: _imports_0,
  alt: "?",
  width: "48",
  height: "48"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-3" }, [
  /*#__PURE__*/_createTextVNode("ログインIDは登録時の"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("メールアドレスとなり、"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("変更できません")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "OK", -1)
const _hoisted_9 = [
  _hoisted_8
]

import { inject, watch } from 'vue';
import AddressInfoForm from './AddressInfoForm.vue';
import StationInfoForm from './StationInfoForm.vue';
import SpouseInfoForm from './SpouseInfoForm.vue';
import AnnualIncomeInfoForm from './AnnualIncomeInfoForm.vue';
import OtherContactsInfoForm from './OtherContactsInfoForm.vue';
import PersonalInfoForm from './PersonalInfoForm.vue';
import AdditionalInfoForm from './AdditionalInfoForm.vue';
import { CareerResumeInfoDetail } from '@/types/career';
import { ValidationResult } from 'vee-validate';

export default /*#__PURE__*/_defineComponent({
  __name: 'BasicInfoForm',
  props: {
    openModal: null,
    closeModal: null,
    activeTab: null,
    isModalActive: { type: Boolean },
    careerData: null,
    setFieldValue: null,
    validateField: null
  },
  setup(__props: any) {

const props = __props as {
    openModal: () => void;
    closeModal: () => void;
    activeTab: string;
    isModalActive: boolean
    careerData?: CareerResumeInfoDetail;
    setFieldValue: <T extends string>(field: T, value: any, opts?: any) => void;
    validateField: (field: string) => Promise<ValidationResult>;
}



const submitBasicInfoFn = inject<(tabId: string) => void>('submitBasicInfo');

watch(() => props.careerData, (newVal) => {
    if (newVal) {
        setFormData(newVal);
    }
});

function setFormData(formData: CareerResumeInfoDetail){
  const toEmpty = (v: any) => v ? v : '';
  let zipId1 = '';
  let zipId2 = '';
  let otherZipId1 = '';
  let otherZipId2 = '';
  let birthDateYear;
  let birthDateMonth;
  let birthDateDay;

  if(formData.birthDate)
  {
    const [yearStr, monthStr, dayStr] = formData.birthDate.split('/');
    birthDateYear = Number(yearStr);
    birthDateMonth = Number(monthStr);
    birthDateDay = Number(dayStr);
  }


  if(formData.zipId && formData.zipId.length == 7)
  {
    zipId1 = formData.zipId.substring(0, 3);
    zipId2 = formData.zipId.substring(3);
  }

  if(formData.otherZipId && formData.otherZipId.length == 7)
  {
    otherZipId1 = formData.otherZipId.substring(0, 3);
    otherZipId2 = formData.otherZipId.substring(3);
  }

  const careerObject: Record<string, any> = {    
    'zipId1': zipId1,
    'zipId2': zipId2,
    'prefId': toEmpty(formData.prefId),
    'addr1': formData.addr1,
    'addr2': formData.addr2,
    'addr3': formData.addr3,
    'prefKanaName': formData.prefKanaName,
    'addr1Kana': formData.addr1Kana,
    'addr2Kana': formData.addr2Kana,
    'nearestStationId': formData.nearestStationId,
    'walkBusFlg': formData.walkBusFlg === '0'? '': toEmpty(formData.walkBusFlg),
    'walkBusTime': formData.walkBusTime,
    'inhabitTypeId': toEmpty(formData.inhabitTypeId),
    'currentAnnualIncomeNum': formData.currentAnnualIncomeNum,
    'monthlyAnnualIncomeNum': formData.monthlyAnnualIncomeNum,
    'yearBonus': formData.yearBonus,
    'allowanceId1': toEmpty(formData.allowanceId1),
    'allowanceId2': toEmpty(formData.allowanceId2),
    'allowanceId3': toEmpty(formData.allowanceId3),
    'allowanceId4': toEmpty(formData.allowanceId4),
    'allowanceNum1': formData.allowanceNum1,
    'allowanceNum2': formData.allowanceNum2,
    'allowanceNum3': formData.allowanceNum3,
    'allowanceNum4': formData.allowanceNum4,

    'spousePresenceFlg': toEmpty(formData.spousePresenceFlg),
    'spouseObligationFlg': toEmpty(formData.spouseObligationFlg),
    'dependentsNum': formData.dependentsNum,
    'hobbySkill': formData.hobbySkill,
    'wishOthers': formData.wishOthers,

    'lastName': formData.lastName,
    'firstName': formData.firstName,
    'lastNameKana': formData.lastNameKana,
    'firstNameKana': formData.firstNameKana,
    'birthDate': formData.birthDate,
    'sexFlg': toEmpty(formData.sexFlg),
    'birthDateY': birthDateYear,
    'birthDateM': birthDateMonth,
    'birthDateD': birthDateDay,
    'telHome': formData.telHome,
    'telCellular': formData.telCellular,

    'emailHome': formData.emailHome,
    'emailCellular': formData.emailCellular,

    'otherZipId': formData.otherZipId,
    'otherZipId1': otherZipId1,
    'otherZipId2': otherZipId2,
    'otherPrefId': toEmpty(formData.otherPrefId),
    'otherAddr1': formData.otherAddr1,
    'otherAddr2': formData.otherAddr2,
    'otherAddr3': formData.otherAddr3,
    'otherAddr1Kana': formData.otherAddr1Kana,
    'otherAddr2Kana': formData.otherAddr2Kana,
    'otherPrefKanaName': formData.otherPrefKanaName
  };

  for (const key in careerObject) {
    props.setFieldValue(key, careerObject[key]);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "basic-info",
    class: _normalizeClass(["tab-content", { 'show': __props.activeTab === 'basic-info' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AddressInfoForm, {
        setFieldValue: __props.setFieldValue,
        "validate-field": __props.validateField
      }, null, 8, ["setFieldValue", "validate-field"]),
      _createVNode(StationInfoForm),
      _createVNode(AnnualIncomeInfoForm),
      _createVNode(SpouseInfoForm),
      _createVNode(AdditionalInfoForm),
      _createVNode(PersonalInfoForm, {
        mypageId: __props.careerData?.mypageId ?? '',
        emailHome: __props.careerData?.emailHome ?? '',
        emailCellular: __props.careerData?.emailCellular ?? '',
        openModal: __props.openModal
      }, null, 8, ["mypageId", "emailHome", "emailCellular", "openModal"]),
      _createVNode(OtherContactsInfoForm, {
        setFieldValue: __props.setFieldValue,
        "validate-field": __props.validateField
      }, null, 8, ["setFieldValue", "validate-field"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          class: _normalizeClass(["p-recommend-form__send -is-next", { 'active': __props.activeTab === 'worksummary' }]),
          href: "#worksummary",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(submitBasicInfoFn)!('#worksummary')), ["prevent"]))
        }, _hoisted_4, 2)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["p-recommend-form__modal js-modal-container", { 'is-active': __props.isModalActive }])
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "p-recommend-form__modal-help-close js-modal-close-trigger",
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (__props.closeModal && __props.closeModal(...args)))
        }, "閉じる"),
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("button", {
          class: "p-recommend-form__modal-help-close-2 js-modal-close-trigger",
          type: "button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (__props.closeModal && __props.closeModal(...args)))
        }, _hoisted_9)
      ]),
      _createElementVNode("div", {
        class: "p-recommend-form__modal-close-area js-modal-close-trigger",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (__props.closeModal && __props.closeModal(...args)))
      })
    ], 2)
  ], 2))
}
}

})